import React from "react";
import { Modal } from "../Modal";
import { Button } from "../../UI/Button";
import { Grid } from "../../UI/Grid";
import { Typography } from "../../UI/Typography";

import { useModalContext } from "../../contexts/ModalContext/context";
import { UserSliderQuestions } from "../UserQuestions/UserSliderQuestions";
import { UserSelectQuestions } from "../UserQuestions/UserSelectQuestions";
import { UserFreeTextQuestions } from "../UserQuestions/UserFreeTextQuestions";

export interface IProps {
  questions: any;
  onHide: any;
  isOpen: boolean;
}

export const PreviewQuestionsModal: React.FC<IProps> = (props) => {
  const { setIsOpen } = useModalContext();

  const handleClose = () => props.onHide(false);

  React.useEffect(() => {
    setIsOpen(props.isOpen);
  }, [props.isOpen]);

  const sliderQuestions = props.questions.SLIDER;
  const selectQuestions = props.questions.SELECT;
  const freeTextQuestions = props.questions.FREE_TEXT;

  return (
    <Modal
      maxWidth="md"
      onClose={handleClose}
      title="Questions Preview"
      actions={
        <Button appearance="primary" onClick={handleClose}>
          Ok
        </Button>
      }
    >
      <Grid container spacing={1} width={706} mt={2}>
        <Grid item xs={12}>
          <Typography variant="h6" px={3}>
            Questions:
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <UserSliderQuestions questions={sliderQuestions} height={36} />
        </Grid>
        <Grid item xs={12}>
          <UserSelectQuestions questions={selectQuestions} />
        </Grid>
        <Grid item xs={12}>
          <UserFreeTextQuestions questions={freeTextQuestions} />
        </Grid>
      </Grid>
    </Modal>
  );
};
